import React from "react";
import {View, Svg, Line, G, Rect, StyleSheet} from "@react-pdf/renderer";
import MarkDamagesOnTrailerPrintout from "../markDamagesOnTrailerPrintout";
import {SideType} from "../../../../../models/transport";
import {DamageLocation, EquipmentType} from "../../../../../models/tcr";
import {OrderFilesUtils} from "../../../../../../helpers/orderFilesUtils";

const tcrReportStyles = StyleSheet.create(OrderFilesUtils.tcrReportStyles);

export default function Rear(): React.ReactElement {
    return (
        <View style={tcrReportStyles.centerPicture}>
            <Svg
                viewBox="0 0 276 300"
                style={tcrReportStyles.pictureSize}
                id="trailer-rear"
            >
                <Rect
                    x="1"
                    y="1"
                    width="137.84"
                    height="200.41"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                />
                <Rect
                    x="137.16"
                    y="1"
                    width="137.84"
                    height="200.41"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                />
                <Rect
                    x="247.72899"
                    y="217.147"
                    width="26.961967"
                    height="81.364357"
                    rx="13.480984"
                    ry="13.480984"
                    fill="#ffffff"
                    stroke="#8e8e8e"
                    strokeWidth="1.92523"
                />
                <Line
                    x1="29.07815"
                    y1="255.62601"
                    x2="246.66534"
                    y2="255.62601"
                    stroke="#8e8e8e"
                    strokeWidth="2.08345"
                />
                <Rect
                    x="1.4656417"
                    y="217.50288"
                    width="26.961967"
                    height="81.364357"
                    rx="13.480984"
                    ry="13.480984"
                    fill="#ffffff"
                    stroke="#8e8e8e"
                    strokeWidth="1.92523"
                />
                <Rect
                    opacity={1}
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="1.9037"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="135.9816"
                    height="99.3013"
                    x="1.084224"
                    y="1.084224"
                    key="TARPAULIN__LEFT_TOP"
                />
                <Rect
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="1.91847"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="135.96683"
                    height="100.85928"
                    x="1.1078507"
                    y="100.39806"
                    key="TARPAULIN__LEFT_BOTTOM"
                />
                <Rect
                    opacity={1}
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="1.91656"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="137.65913"
                    height="99.421463"
                    x="137.3508"
                    y="1.0322149"
                    key="TARPAULIN__RIGHT_TOP"
                />
                <Rect
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="1.93021"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="137.46756"
                    height="100.98266"
                    x="137.37386"
                    y="100.47729"
                    key="TARPAULIN__RIGHT_BOTTOM"
                />
                <Rect
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="33.807831"
                    height="32.384342"
                    x="241.25153"
                    y="181.92776"
                    key="LIGHT-2"
                />
                <Rect
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="33.807831"
                    height="32.384342"
                    x="0.9998951"
                    y="181.8038"
                    key="LIGHT-1"
                />
                <G
                    transform="translate(-71.397563,10.085366)"
                    key="TARPAULIN__LEFT_TOP.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.REAR}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.LEFT_TOP}
                    />
                </G>
                <G
                    transform="translate(70.778712,10.840284)"
                    key="TARPAULIN__RIGHT_TOP.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.REAR}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.RIGHT_TOP}
                    />
                </G>
                <G
                    transform="translate(68.010678,113.25753)"
                    key="TARPAULIN__RIGHT_BOTTOM.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.REAR}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.RIGHT_BOTTOM}
                    />
                </G>
                <G
                    transform="translate(-73.159039,109.73458)"
                    key="TARPAULIN__LEFT_BOTTOM.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.REAR}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.LEFT_BOTTOM}
                    />
                </G>
                <G
                    transform="translate(121.60988,158.55263)"
                    key="LIGHT.damage-2"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.REAR}
                        equipmentType={EquipmentType.LIGHT}
                        damageLocation={null}
                    />
                </G>
                <G
                    transform="translate(-118.95741,158.80427)"
                    key="LIGHT.damage-1"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.REAR}
                        equipmentType={EquipmentType.LIGHT}
                        damageLocation={null}
                    />
                </G>
            </Svg>
        </View>
    );
}